// Central registry of localStorage keys used across the frontend, the
// browser extension, and the Tampermonkey user scripts.
//
// IMPORTANT: the exact string values are a public contract:
// - The extension reads `EXPORTNOOK_AWB_DATA` and `EXPORTNOOK_CANADA_TAX_DATA`
// - The Canada-tax Tampermonkey script reads `EXPORTNOOK_CANADA_TAX_DATA`
//   and `CANADA_TAX_FIRST_PAGE_FILLED`
// - Backups and migrations depend on the other keys
// If you need to rename a key, add the new one AND keep the old constant as
// a deprecated alias until all consumers have migrated.

export const STORAGE_KEYS = Object.freeze({
  // Auth
  authToken: 'authToken',
  user: 'user',
  lastActivity: 'lastActivity',
  lastTokenRefresh: 'lastTokenRefresh',

  // GST selection (also listened to via window event 'gstSelectionChanged')
  selectedGST: 'selectedGST',

  // UI preferences
  invoicesColumnVisibility: 'invoices_column_visibility',

  // Extension / Tampermonkey bridges (do not rename without updating both)
  exportnookAwbData: 'EXPORTNOOK_AWB_DATA',
  exportnookCanadaTaxData: 'EXPORTNOOK_CANADA_TAX_DATA',
  canadaTaxFirstPageFilled: 'CANADA_TAX_FIRST_PAGE_FILLED',

  // Local caches / address book
  addressBookV1: 'address_book_v1',
  banksV1: 'banks_v1',
  invoicesV1: 'invoices_v1',
  packingLists: 'packing_lists',
  recentItemsV1: 'recent_items_v1',
  exporterProfileV1: 'exporter_profile_v1',
  edpmsReconciliation: 'edpms_reconciliation_v1',
});

export default STORAGE_KEYS;
